import { useEffect } from 'react'
import { isAndroid } from 'react-device-detect'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { routeName } from '~/@common/constants'
import authService from '~/@common/services/auth.service'
import { getEntrancePage } from '~/@common/utils/getEntrancePage'

/**
 * `/qr?worksheetId=...&dateTime=...` 진입용 브릿지 페이지.
 *
 * 구 베이직학생앱 `/Users/choi/dev/mathflat-student/src/page/QR/QR.tsx`의 딥링크 로직을 복원.
 * - 네이티브 앱이 설치되어 있으면 intent:// (Android) 또는 mathflat-student:// (iOS) 스킴으로 앱 실행
 * - 앱 미설치 환경: appRouter loader가 소비하는 redirectURI로 학습지 채점 페이지로 이동
 */
const QRPage = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const dateTime = searchParams.get('dateTime')
  const worksheetId = searchParams.get('worksheetId')

  useEffect(() => {
    if (!worksheetId || !dateTime) {
      navigate(getEntrancePage(authService.userType), { replace: true })
      return
    }

    // 네이티브 앱 자동 실행 시도
    const link = document.createElement('a')
    link.href = isAndroid
      ? `intent://qrcode?worksheetId=${worksheetId}&dateTime=${dateTime}#Intent;S.browser_fallback_url=${encodeURIComponent(
          `${window.location.origin}/worksheet/${worksheetId}/${dateTime}/scoring`,
        )};scheme=mathflat-student;package=iclass.mathflat.parent.student;end`
      : `mathflat-student://qrcode?worksheetId=${worksheetId}&dateTime=${dateTime}`
    link.click()

    // 앱 미설치 환경
    const redirectURI = `/worksheet/${worksheetId}/${dateTime}/scoring`
    navigate(redirectURI, { replace: true })
  }, [dateTime, worksheetId])

  return <div />
}

export default QRPage
